<template>
    <div class="page max-content">
        <div class="charge_info">
            <p style="color:#901D22">注册费用信息：</p>
            <p>线下参会注册费用1000元</p>
            <p>线上参会注册费用200元</p>
            <p>以下情况注册费用减半：</p>
            <p>1.护理人员凭执业证书或资格证书减半；</p>
            <p>2.全日制在读学生凭学生证减半;</p>
            <p>3.金山血液透析血管通路联盟成员单位医护人员减半。</p>
        </div>
        <div class="ways">
            <h4 v-if="!show_ways" style="color: #901D22;">{{info.status==1?'认证成功，请前往大会直播页观看':'注册成功，回放将在九月初开放，敬请关注'}}</h4>
            <h4 v-if="show_ways">请选择<span>注册方式</span></h4>
            <div v-if="show_ways" class="ways_list">
                <div @click="goRegister(1)">
                    <img src="@/assets/images/Meeting/charge_xianshang.png" alt="">
                    <span>线上注册</span>
                </div>
                <div @click="goRegister(2)">
                    <img src="@/assets/images/Meeting/charge_xianxia.png" alt="">
                    <span>线下注册</span>
                </div>
            </div>
        </div>
        <div class="charge_info">
            <p style="color:#901D22">温馨提示：</p>
            <p>1. 本次会议注册于2024.8.25中午12:00截止；</p>
            <p>2.主会场直播免费观看，注册学员可以观看本次会议主会场及分会场录播回放。回放于会后7个工作日上线。</p>
        </div>
    </div>

</template>

<script>
import { MeetingRegInfo } from '../../../config/interface.js'

export default {
    data() {
        return {
            info: null,
            show_ways: true
        }
    },
    computed: {
        meeting_id() {
            return this.$route.query.meeting_id ? this.$route.query.meeting_id : (this.$route.query.id ? this.$route.query.id : this.$route.query.MT_id);
        }
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        goRegister(val) {
 
                common.confirm('提示', '注册方式一旦选择无法修改，是否确认下一步？', () => {
                    if (this.info) { //	1线上2线下
                        this.$router.replace({
                            path: "/vascularNews/Meeting/chargeRegister",
                            query: { type: val, step: this.info.step, meeting_id: this.meeting_id }
                        });
                    }
                })
        

        },
        getDetail() {
            const url = MeetingRegInfo;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "get";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.info = res.data
                        if(res.data.status==1 || (res.data.status==0 && res.data.reg_status == 1)){
                            this.show_ways = false;
                            return;
                        }
                      
                        // else if (res.data.status==0 && res.data.reg_status == 1 && res.data.step <= 3) {
                        //     this.$router.replace({
                        //         path: "/vascularNews/Meeting/chargeRegister",
                        //         query: { type: this.info.type_id, step: this.info.step, meeting_id: this.meeting_id }
                        //     });
                        // }

                    }
                })
        },
    }
}
</script>

<style lang="scss">
.page {
    width: 100%;
    padding: 15px;

    .charge_info {
        color: #666;
        font-size: 13px;
        font-family: PingFang SC;
        line-height: 22px;
        margin-block: 20px;

    }

    .ways {
        h4 {
            display: flex;
            font-size: 18px;

            span {
                display: block;
                height: 20px;
                border-bottom: 5px solid #FFBFBF;
            }
        }

        .ways_list {
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin-top: 20px;
            margin-block: 30px;

            >div {
                width: 165px;
                height: 72px;
                background: #FFF3F3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                border-radius: 5px;

                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 20px;

                }

            }
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/charge.vue